/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FolderAddToIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Folder Add To',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m12.064 27.418 8.356-9.076a3.086 3.086 0 0 1 2.213-.961 3.044 3.044 0 0 1 3.041 3.037v.943A13.842 13.842 0 0 1 34 25.605V11a1 1 0 0 0-1-1H2v21a1 1 0 0 0 1 1h13.285Z"
    />
    <path
      d="M23.273 23.6v-3.182a.636.636 0 0 0-1.086-.45l-6.86 7.449 6.86 7.449a.636.636 0 0 0 1.086-.45v-3.229a11.687 11.687 0 0 1 11.916 4.632.45.45 0 0 0 .811-.26C36 33.638 33.808 23.6 23.273 23.6ZM16 8H2V5.5A1.5 1.5 0 0 1 3.5 4h7.672a2 2 0 0 1 1.414.586Z"
    />
  </svg>`;
};
